import './JPage.scss';
import React, { FC, PropsWithChildren, useMemo } from 'react';
import { CMSPage } from "../models";
import { JCMSStaticSections } from '../JCMSStaticSections/JCMSStaticSections';
import { JSectionsWrapper } from '../JSectionsWrapper';
import { WalletInfoMiniBanner } from '../WalletInfoMiniBanner';
import { JProjectIntro, JPageHeader } from '../JBanner/components';
import { useJCommonContext } from '../JCommonProvider';
import { JSection } from '../JSection';
import { JCommunicationText, JCommunicationTextProps } from './components';
import { JPageHeaderTitle } from '../JHeaderTitle';
import Helmet from "react-helmet";

export interface JCMSPageProps extends CMSPage {
    projectIntroChildren?: JSX.Element,
    communicationProps?: JCommunicationTextProps,
    context?: string,
    className?: string
}

export const JPage: FC<PropsWithChildren<JCMSPageProps>> = ({ options, ...props }) => {
    if (props.enabled === false) return <></>

    const { walletData } = useJCommonContext()

    const context = useMemo(() => props.context || 'generic', [props.context]);
    const noMargin = props?.banner?.enabled && props?.sections?.length === 0;

    return (
        <div className={`jpage ${props.className || ''} ${noMargin ? 'jpage-no-margin' : ''} jpage-context-${context}`} role="main" id={"main-container"}>
            {
                options?.metaTags?.title &&
                <Helmet>
                    <title>{options?.metaTags?.title}</title>
                    {options?.metaTags?.description && <meta name="description" content={options?.metaTags?.description} />}
                </Helmet>
            }
            {
                props?.wallet && <WalletInfoMiniBanner walletData={walletData} />
            }
            {
                (props?.banner?.enabled || props?.communicationProps) && (
                    <div className='jpage-item'>
                        {
                            props.banner?.enabled && (
                                props?.projectIntroChildren ? (
                                    <JProjectIntro  {...props?.banner}>
                                        {props?.projectIntroChildren}
                                    </JProjectIntro>
                                ) : (
                                    <JPageHeader
                                        {...props?.banner}
                                    />
                                )
                            )
                        }
                        {
                            props?.communicationProps && (
                                <JCommunicationText {...props?.communicationProps} container={props?.banner?.options?.container || props?.communicationProps?.container} />

                            )
                        }
                    </div>

                )
            }
            {
                (props?.title || props?.text || props?.subTitle) && (
                    <div className='jpage-item jpage-title-header'>
                        <JSection>
                            <JPageHeaderTitle
                                title={props?.title}
                                subTitle={props?.subTitle}
                                text={props?.text}
                                align={options?.headerAlign}
                            />
                        </JSection>
                    </div>

                )
            }
            {
                props?.children && (
                    <div>
                        <JSectionsWrapper>
                            {props?.children}
                        </JSectionsWrapper>
                    </div>
                )
            }
            {
                !!props?.sections?.length && (
                    <div>
                        <JCMSStaticSections sections={props?.sections || []} />
                    </div>

                )
            }
        </ div>
    )
}

